"use client";

import { persistDiscoverTrafficSource } from "@/lib/analytics/discover-attribution";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

export function DiscoverTrafficSourceSync() {
  const searchParams = useSearchParams();

  useEffect(() => {
    persistDiscoverTrafficSource(searchParams);
  }, [searchParams]);

  return null;
}
